<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 84px);"
      >
        <div class="contact"
          @scroll="handleScroll"
        >
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">新規契約申し込み</span> ／ <span class="breadcrumb-link current">新規契約申し込み内容の確認</span> ／ <span class="breadcrumb-link">新規契約申し込みの完了</span>

            </div>
            <h1 class="hdg02">お申し込み内容の確認</h1>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">下記内容をご確認いただき、「契約を申し込む」ボタンを押下して申し込みを確定してください。</p>
              <h2 class="hdg03 mb28">お申し込み内容</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">弊社紹介社員</span>
                        </th>
                        <td class="border-none">
                          <p class="contact-content-table-txt">{{ group1.introducer }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">備考</span>
                        </th>
                        <td class="border-none">
                          <p class="contact-content-table-txt" v-html="group1.noteDisp"></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg03 mb28 estimate-print-ttl">購入を希望するパッケージ</h2>
              <a href="/lc/app/pc/new-application-print" target="_blank" class="estimate-print txt-blue">お見積もり印刷画面を表示 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
              <div class="purchase-summary mb40">
                <p class="purchase-summary-heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ group1.totalFeeDisp }}</strong>円（税込）</p>
              </div>

              <div class="visible-pc mb40">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" 
                  class="tbl04 box-package">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ item.sub_total_fee_disp }}</strong>円（税込）</p>
                  </div>
                  <div class="tbl04-bodyarea">
                    <table class="tbl04-table">
                      <colgroup>
                        <col style="width:35%;">
                        <col style="width:15%;">
                        <col style="width:35%;">
                        <col style="width:15%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th class="ta-center">商品名</th>
                          <th class="ta-center">ライセンス数</th>
                          <th class="ta-center">ライセンス期間</th>
                          <th class="ta-center">価格（税込）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                          <th>
                            <div class="tbl04-table-txt">{{ item2.name }}</div>
                          </th>
                          <td>
                            <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                          </td>
                          <td>
                            <div class="tbl04-table-txt">12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                          </td>
                          <td class="ta-right">
                            <div class="tbl04-table-txt">{{ item2.price_disp }} 円</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <template v-if="item.option_products.length > 0">
                      <div class="tbl04-bodyarea-hdg">
                        <h4 class="hdg04">オプション</h4>
                      </div>
                      <table class="tbl04-table">
                        <colgroup>
                          <col style="width:35%;">
                          <col style="width:15%;">
                          <col style="width:35%;">
                          <col style="width:15%;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th class="ta-center">商品名</th>
                            <th class="ta-center">ライセンス数</th>
                            <th class="ta-center">ライセンス期間</th>
                            <th class="ta-center">価格（税込）</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                            <th class="pl40">
                              <div class="tbl04-table-txt">{{ item3.name }}</div>
                            </th>
                            <td>
                              <div class="tbl04-table-txt">{{ item3.license_number }}</div>
                            </td>
                            <td>
                              <div class="tbl04-table-txt">12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                            </td>
                            <td class="ta-right">
                              <div class="tbl04-table-txt">{{ item3.price_disp }} 円</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </div>
                </div>
              </div>

              <h2 class="hdg03">お支払い方法</h2>
              <div class="contract-content-payment mb40">
                <p class="txt">{{ group1.paymentName }}</p>
              </div>

              <div class="contact-submit">
                <router-link to="/pc/new-application-input" class="contact-submit-link">
                  <FontawesomeIcon :icon="['fas','angle-left']" class="icn" />
                  戻る
                </router-link>
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.onSubmitButtonClicked">契約を申し込む</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import * as logicLoggedinNewApplication from '@/logic/new-application/LoggedinNewApplication'

export default defineComponent({
  components: {
    PCMenu
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLoggedinNewApplication.getGroupConfirm()
  
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.breadcrumb {
  color: $color-content;
  font-size: 1.4rem;
  margin-bottom: 16px;
  &-link {
    color: $color-inactive;
    &.current {
      color: $color-content;
    }
  }
}
.contact {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-lead{
      padding: 30px 0 0;
      border-top: 1px solid $color-line;
      font-size: 1.8rem;
      color: #555;
    }
    &-list {
      list-style: none;
      margin-bottom: 32px;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
        .contact-content-table {
          th,td {
            padding: 0 20px;
          }
        }
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 20px;
        }
      }
      tbody {
        th,td {
          padding: 16px 20px;
          border-top: 1px solid $color-line;
          vertical-align: baseline;
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-txt {
        color: $color-content;
        font-size: 1.6rem;
        line-height: 2;
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .contact-content-table-link {
          margin-left: 20px;
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
      }
    }
  }
  &-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    &-link {
      width: 80px;
      display: flex;
      align-items: center;
      color: $color-link;
      font-size: 1.4rem;
      @include hoverOpacity;
      .icn {
        margin-right: 10px;
      }
    }
    &-button {
      width: 230px;
      .btn {
        font-size: 1.4rem;
        @include hoverOpacity;
      }
    }
  }

  .estimate-print-ttl {
    display: inline-block;
  } 
  .estimate-print {
    margin-left: 40px;
  }
  .tbl04-hdgarea .heading-sub {
    font-size: 16px;
    line-height: 1.625;
    margin-top: 8px;
    color: $color-content;
    span{
      font-weight: bold;
      margin-right: 25px;
      color: $color-hdg;
    }
    strong{
      font-size: 24px;
      font-weight: bold;
      margin: 0 10px;
      color: $color-hdg;
    }
  }
}
.list-inline {
  a {
    @include hoverOpacity;
  }
}
.footer {
  margin-top: 72px;
  margin-bottom: 40px;
  text-align: center;
  a {
    font-size: 1.2rem;
  }
}
.box-package{
  border: 1px solid #ddd;
  border-radius: 5px;
  & + .box-package{
    margin-top: 50px;
  }
  .tbl04-hdgarea{
    border-top: none;
  }
  .tbl04-bodyarea{
    border-bottom: none;
    margin-bottom: 0;
  }
  & + .contact-submit{
    margin-top: 30px;
  }
}

</style>
